export default {"src":"/_next/static/media/tv_logo.44413287.svg","height":20,"width":414,"blurWidth":0,"blurHeight":0};